/**
 * @deprecated
 */
export const ZERO_SIXTEEN_ZERO = '0.16.0';
export const ZERO_SIXTEEN = '0.16';
/**
 * @deprecated
 */
export const ZERO_FOURTEEN_ZERO = '0.14.0';
export const ZERO_FOURTEEN = '0.14';
